import { GiftBoxStatus, GiftCouponStatus } from '@models/gift/common';

export const GiftBoxStatusKr: Record<GiftBoxStatus, string> = {
  USED: '사용완료',
  EXPIRED: '기간만료',
  PENDING: '사용대기',
  CANCELED: '결제취소',
};

export const GiftCouponStatusKr: Record<GiftCouponStatus, string> = {
  ISSUED: '결제 완료',
  USED: '사용 완료',
  CANCELED: '결제 취소',
  EXPIRED: '기간 만료',
  CANCEL_FAILED: '취소 실패',
  SENT: '발송 완료',
  SEND_FAILED: '발송 실패',
  OFF_USED: '오프라인 사용 완료',
  DEACTIVATED: '비활성화',
};
